import { createSelector } from '@atlassian/eoc-rss-helpers';

import { type SpotlightStore } from '../state/types';

const getTriggerStatus = createSelector<
	SpotlightStore,
	/* Hook input */
	string, // Spotlight key
	/* Selector output */
	boolean, // Trigger status
	/* Selector inputs */
	Record<string, boolean>, // Spotlights
	string // Spotlight key
>(
	(state, _) => state.spotlights,
	(_, id) => id,
	(spotlights, id) => {
		return spotlights?.[id] ?? false;
	},
);

export const selectors = {
	getTriggerStatus,
};
